

function SearchText({ title, text }) {
    return (
        <div className="flex flex-row-reverse mb-5">
            <p className="w-28 text-right">{title}</p>
            <p className="w-5/6 p-2 text-sm h-40 rounded bg-white text-right text-slate-500 border border-slate-200">{text}</p>
        </div>
    )
}
export default SearchText;